<div class="print-header">
  <div>
    Lot {{lotBlock()}} Punchlist
  </div>
  <div>
    {{today | date: "MM/dd/yyyy"}}
  </div>
</div>

<div class="app-print-items-container"
     data-testid="print-items-container"
     role="main"
     aria-label="Open items management">
  <div class="app-print-items-header"
       data-testid="print-items-header"
       role="region"
       aria-label="Page Header">
    <div class="app-print-items-header-top"
         data-testid="print-items-header-top">
      <h1 class="app-print-items-title"
          data-testid="print-items-title">Lot {{lotBlock()}} Punchlist</h1>
      <div class="app-print-items-lot-address"
           data-testid="print-items-lot-address">{{lotAddress()}}</div>
    </div>
    <div class="app-print-items-header-bottom"
         data-testid="print-items-header-bottom">
      <div class="app-print-items-cm-name"
           data-testid="print-items-cm-name">
        <b>CM:</b> {{CMName}}
      </div>
      <div class="app-print-items-cm-name"
           data-testid="print-items-total-issues">
        <b>Total issues:</b> {{totalNumberOfIssues()}}
      </div>
      <div class="app-print-items-date"
           data-testid="print-items-date">
        <b>Date:</b> {{ date() ? (date() | date:'MM/dd/yyyy') : 'TBD' }}
      </div>
    </div>
  </div>
  @if (isLoadingFullImages) {
    <div class="loading-full-images"
         data-testid="loading-full-images"
         role="status"
         aria-live="polite">
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
      <p-skeleton width="125px"
                  height="125px"></p-skeleton>
    </div>
  }
  @else {
    <div class="app-print-items"
         data-testid="print-items-content"
         role="region"
         aria-label="Issues list">
      <div class="issues-list"
           data-testid="issues-list">
        <div class="issues-container"
             data-testid="issues-container"
             role="list"
             [attr.aria-label]="'Issues list'">
          @for (issue of issuesToPrint(); track issue.id) {
            <print-view-issue-item [issue]="issue"
                                   [media]="mediaMap().get(issue.identifier) || []"
                                   (imageError)="onImageError()"
                                   [attr.data-testid]="'issue-item-' + issue.id"
                                   [openItemsSelectionType]="openItemsSelectionType()"
                                   role="listitem">
            </print-view-issue-item>
          }
        </div>
      </div>
    </div>
  }

  <div class="print-items-footer"
       data-testid="print-items-footer"
       role="region"
       aria-label="Footer Actions">
    <div class="footer-buttons"
         data-testid="footer-buttons"
         role="group"
         aria-label="Print view actions">
      <button class="footer-btn print-items-btn"
              (click)="onPrint()"
              data-testid="print-items-btn">
        Print
      </button>
    </div>
  </div>

</div>

<div class="pulte-group-logo">
  <img width="40px"
       class="pulte-group-image"
       src="assets/logos/brand-PulteHomes.svg" />
</div>